export const PaymentPayMethodsObject = {
  CASH: 'cash',
  CARD: 'card',
  SUB: 'sub',
  CERT: 'cert',
}

export const PaymentPayMethods =  PaymentPayMethodsObject.CASH || PaymentPayMethodsObject.CARD || PaymentPayMethodsObject.SUB || PaymentPayMethodsObject.CERT;
export type TPaymentPayMethods = typeof PaymentPayMethods;